import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PageLayout, PageContentPreloader, BasicModal, NoItemsPanel } from 'common/components';
import noPartnersImage from 'common/images/noPartners.svg';

import { getPartnerAccounts } from '../../../_redux';
import { getPartnershipWithdrawalAccounts } from '../../_redux';

import { PartnerAccountsTable, PartnerAccountWithdrawalForm } from '../../_components';
import WarningMessage from '../../../_components/WarningMessage';

import { staticStyles } from './style';

const PartnershipAccountsPage = ({
  getPartnerAccounts,
  partnerAccounts,
  partnerAccountsIsLoaded,
  partnershipWithdrawalAccounts,
  getPartnershipWithdrawalAccounts,
  history,
  profile,
}) => {
  useEffect(() => {
    getPartnerAccounts();
  }, [getPartnerAccounts]);

  const [isWithdrawalModalOpen, setIsWithdrawalModalOpen] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState(0);

  const toggleWithdrawalModal = () => setIsWithdrawalModalOpen(!isWithdrawalModalOpen);
  const notSimplePartnerAccounts = partnerAccounts.filter(item => item.partnershipSystem !== 'simple');

  const handleWithdrawClick = id => {
    setSelectedAccountId(id);
    getPartnershipWithdrawalAccounts(id);
    toggleWithdrawalModal();
  };

  return (
    <PageLayout captionSlug="clientAccounts">
      <PageContentPreloader ready={partnerAccountsIsLoaded}>
        {profile.isIbPartnerAccountContractPending && (
          <WarningMessage
            bodyTextId="additionalPartnerAccountContractPrompt"
            buttonTextId="partnershipSignNow"
            onButtonClick={() => history.push('/partnership/ib-contract')}
            className="PartnershipAccountsPage__contract-warning"
          />
        )}
        {notSimplePartnerAccounts.length ? (
          <PartnerAccountsTable
            data={notSimplePartnerAccounts}
            onWithdrawClick={id => handleWithdrawClick(id)}
            onRowClick={id => history.push(`/partnership/account/${id}`)}
          />
        ) : (
          <NoItemsPanel icon={noPartnersImage} captionSlug="noPartnerAccountsCreated" />
        )}
      </PageContentPreloader>

      <BasicModal
        isOpen={isWithdrawalModalOpen}
        captionId="clientWithdrawPartnerAccount"
        onRequestClose={toggleWithdrawalModal}>
        <PartnerAccountWithdrawalForm
          partnerAccountId={selectedAccountId}
          accounts={partnershipWithdrawalAccounts}
          toggleWithdrawalModal={toggleWithdrawalModal}
        />
      </BasicModal>

      <style jsx>{staticStyles}</style>
    </PageLayout>
  );
};

PartnershipAccountsPage.propTypes = {
  partnerAccounts: PropTypes.array.isRequired,
  partnerAccountsIsLoaded: PropTypes.bool.isRequired,
  getPartnerAccounts: PropTypes.func.isRequired,
  partnershipWithdrawalAccounts: PropTypes.array.isRequired,
  getPartnershipWithdrawalAccounts: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  profile: PropTypes.object,
};

PartnershipAccountsPage.defaultProps = {
  profile: {},
};

export default connect(
  state => ({
    profile: state.user.profile,
    partnerAccounts: state.client.common.partnerAccounts,
    partnerAccountsIsLoaded: state.client.common.partnerAccountsIsLoaded,
    partnershipWithdrawalAccounts: state.client.partnership.partnershipWithdrawalAccounts,
  }),
  {
    getPartnerAccounts: () => getPartnerAccounts.request(),
    getPartnershipWithdrawalAccounts: partnerAccountId =>
      getPartnershipWithdrawalAccounts.request({ partnerAccountId }),
  }
)(PartnershipAccountsPage);
export { PartnershipAccountsPage };
